import * as Yup from 'yup'

import { urlValidation } from 'utils'

export const validationSchema = Yup.object({
  billingReference: urlValidation.max(100, 'Max length of 100 characters').required('Billing reference is required'),
})
